import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

export const PoppersContainer = styled.div`
  opacity: 0;
  animation: ${fadeIn} 0.15s ease-in 0.15s forwards;
  z-index: ${(p) => p.theme.zIndexes.overlay};
`;

export const Arrow = styled.div`
  position: absolute;
  width: 15px;
  height: 15px;
  &[data-placement*='bottom'] {
    top: 0;
    left: 0;
    margin-top: 5px;
    width: 3em;
    height: 1em;
    &::before {
      border-width: 0 1.5em 1em 1.5em;
      border-color: transparent transparent ${(p) => p.theme.colors.secondary} transparent;
    }
  }
  &[data-placement*='top'] {
    bottom: 0;
    left: 0;
    margin-bottom: 5px;
    width: 3em;
    height: 1em;
    &::before {
      border-width: 1em 1.5em 0 1.5em;
      border-color: ${(p) => p.theme.colors.secondary} transparent transparent transparent;
    }
  }
  &[data-placement*='right'] {
    left: 0;
    margin-left: 5px;
    height: 3em;
    width: 1em;
    &::before {
      border-width: 1.5em 1em 1.5em 0;
      border-color: transparent ${(p) => p.theme.colors.secondary} transparent transparent;
    }
  }
  &[data-placement*='left'] {
    right: 0;
    margin-right: 5px;
    height: 3em;
    width: 1em;
    &::before {
      border-width: 1.5em 0 1.5em 1em;
      border-color: transparent transparent transparent ${(p) => p.theme.colors.secondary};
    }
  }
  &::before {
    content: '';
    margin: auto;
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
  }
`;

export const TooltipContainer = styled.div`
  display: block;
  margin: 15px;
  padding: 20px;
  max-width: 490px;

  border-radius: 2px;
  background-color: ${(p) => p.theme.colors.secondary};
  text-align: start;
`;
